import { validateSearchParams } from "../validation";

/**
 * Parses search params in the source string. Accepts either the search portion
 * of an href, e.g. ?param=value, as well as the entire href.
 * @param {string} source The href or query portion of an href.
 * @param {ObjectSchema} validations Optional validations to run against the parameters
 * @returns An object with search param names and values. If the parameter is repeated
 * (I.e. `vendors` in Car Booking) it will bundle the values in an Array.
 */
export const getSearchParams = (source, validations) => {
  let results = {
    errors: [],
    searchParams: {},
  };

  if (source) {
    let searchParamsList;

    try {
      const url = new URL(source);

      searchParamsList = url.searchParams;
    } catch {
      searchParamsList = new URLSearchParams(source);
    }

    results.searchParams = {};

    for (const [key, value] of searchParamsList.entries()) {
      if (Array.isArray(results.searchParams[key])) {
        results.searchParams[key].push(value);
      } else if (results.searchParams[key]) {
        const previousValue = results.searchParams[key];

        results.searchParams[key] = [previousValue, value];
      } else {
        results.searchParams[key] = value;
      }
    }

    if (validations) {
      results = validateSearchParams(results.searchParams, validations);
    }
  }

  return results;
};
